"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  compact: {
    isCompact: false,
    isOpen: false,
    forceCompact: false
  },
  schemes: [{
    name: "Resource Watch",
    mainColor: "#40B2CE",
    category: ["#40B2CE", "#2E75AD", "#F9B746", "#ED4A4D", "#68B631", "#C22E7A", "#F478B7", "#63D2B9", "#F0812D", "#9E1D0D", "#A7E9E3", "#BAD771", "#393F44", "#CACCD0", "#717171"]
  }],
  color: "#C32D7B",
  slider: {
    track: "#a3daf3",
    trackBackground: "#f5f5f5"
  },
  selectedScheme: null,
  font: "lato",
  titleSize: "auto",
  captionSize: "auto",
  axisTitleSize: "auto"
};
exports["default"] = _default;